import React from 'react';
import {useParams} from 'react-router-dom';

import LoadingSpinner from 'src/components/LoadingSpinner';
import PageContainer from 'src/components/PageContainer';
import PageTitle from 'src/components/PageTitle';
import {useForecastEvaluation} from 'src/hooks/eval/useForecastEval';

type Params = {siteId: string; forecastId: string};

export default function EvalForecastDetail() {
  const {siteId, forecastId} = useParams() as Params;

  const {evaluation, isLoaded} = useForecastEvaluation(siteId, forecastId);

  return (
    <PageContainer>
      <PageTitle
        pageStack={[
          {title: 'Eval', to: '/eval'},
          {title: siteId, to: '/:currentOrgIdPrefix/eval/:siteId'},
          {
            title: forecastId,
            to: '/:currentOrgIdPrefix/eval/:siteId/:forecastId',
          },
        ]}
      />

      {!isLoaded && (
        <div className="py-6">
          <LoadingSpinner />
        </div>
      )}

      {isLoaded && (
        <div className="rounded-md border border-gray-200 bg-white p-4">
          <div className="font-medium text-gray-900 mb-3">Forecast evaluation</div>
          <pre className="text-xs overflow-auto bg-gray-50 p-3 rounded">
            {JSON.stringify(evaluation ?? null, null, 2)}
          </pre>
        </div>
      )}
    </PageContainer>
  );
}
